import type { CmsApiBlockVisible } from '#/modules/cms/api/types/CmsApiBlock';

export const VISIBILITY_PERMISSIONS = {
  orgAdmin: true,
  nonOrgAdmin: true,
  recognized: true,
  unrecognized: true,
} satisfies CmsApiBlockVisible;
